<template>
            <md-list class="md-double-line">
            <md-subheader>Dates</md-subheader>

            <md-list-item>
              <md-icon class="md-primary">transfer_within_a_station</md-icon>
              <div class="md-list-item-text">
                <span>{{moveInComputed}}</span>
                <span>Move In</span>
              </div>
            </md-list-item>

            <md-list-item class="md-inset" v-if="booking.termType == 'unspecified'">
              <div class="md-list-item-text">
                <span>Unspecified term</span>
                <span
                  v-if="noticePeriodMonthsComputed"
                >{{noticePeriodMonthsComputed}} month notice period</span>
                <span v-if="noticeGivenAtComputed">Notice given at {{noticeGivenAtComputed}}</span>
              </div>
            </md-list-item>

            <md-list-item class="md-inset" v-else>
              <div class="md-list-item-text">
                <span>{{moveOutComputed}}</span>
                <span>Move Out</span>
              </div>
            </md-list-item>

            <div v-if="periodicPayments">
              <md-divider></md-divider>
              <md-list-item>
                <md-icon class="md-primary">calendar_today</md-icon>
                <div class="md-list-item-text final-rent-container">
                  <span>{{monthlyRent}}{{currencySign}}</span>
                  <span>Monthly</span>
                </div>
              </md-list-item>
            </div>
            <md-list-item v-if="dailyRentTotal">
              <md-icon class="md-primary">repeat_one</md-icon>
              <div class="md-list-item-text">
                <span>{{dailyRentTotal}}{{currencySign}}</span>
                <span>Total Rent</span>
              </div>
            </md-list-item>
            <md-list-item v-if="deposit">
              <md-icon class="md-primary">repeat_one</md-icon>
              <div class="md-list-item-text">
                <span>{{deposit}}{{currencySign}}</span>
                <span>Deposit</span>
              </div>
            </md-list-item>
            <md-list-item class="md-inset" v-if="cleaningFee">
              <div class="md-list-item-text">
                <span>{{cleaningFee}}{{currencySign}}</span>
                <span>Cleaning</span>
              </div>
            </md-list-item>
          </md-list>
</template>

<script>
import { getMonth } from "../../functions.js";
import { formatTimeToDDMMYYFromString } from "../../timeFunctions.js";
export default {
  props: {
    booking: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      monthlyRent: "",
      dailyRentTotal: "",
      preDaysRent: "",
      preMonth: "",
      postDaysRent: "",
      postMonth: "",
      deposit: "",
      cleaningFee: "",
      monthlyPeriod: false,
      dailyPeriod: false,
      currencySign: "",
      periodicPayments: false
    };
  },
  computed: {
    moveInComputed() {
      return formatTimeToDDMMYYFromString(this.booking.periodStart);
    },
    moveOutComputed() {
      return formatTimeToDDMMYYFromString(this.booking.periodEnd);
    },
    noticeGivenAtComputed() {
      return formatTimeToDDMMYYFromString(this.booking.noticeGivenAt);
    },
    noticePeriodMonthsComputed() {
      return this.booking.noticePeriodMonths;
    }
  },
  created() {
    this.setPricingDetails(this.booking);
    this.setFees(this.booking);
  },
  methods: {
    setPricingDetails(booking) {
      if (booking.agreedDeal.priceTier == "month") {
        this.periodicPayment = true;
        this.monthlyPeriod = true;
        this.dailyPeriod = false;
        this.monthlyRent = booking.agreedDeal.rentMonthly;
        if (booking.agreedDeal.rentForPreDays.total) {
          this.preMonth = getMonth(booking.periodStart);
          this.preDaysRent = booking.agreedDeal.rentForPreDays.total;
        }
        if (booking.agreedDeal.rentForPostDays.total) {
          this.postMonth = getMonth(booking.periodEnd);
          this.postDaysRent = booking.agreedDeal.rentForPostDays.total;
        }
      } else if (booking.agreedDeal.rentDaily) {
        this.periodicPayment = false;
        this.monthlyPeriod = false;
        this.dailyPeriod = true;
        this.dailyRentTotal = (
          booking.agreedDeal.rentDaily *
          booking.agreedDeal.stayLength.totalNrOfDays
        ).toFixed(2);
      }

      if (booking.currency == "eur") {
        this.currencySign = "€";
      }
    },
    setFees(booking) {
      this.setDeposit(booking.fees.deposit);
      this.setCleaningFee(booking.fees.cleaningFee);
    },
    setDeposit(newDeposit) {
      this.deposit = newDeposit;
    },
    setCleaningFee(newCleaningFee) {
      this.cleaningFee = newCleaningFee;
    },
    setPeriodicPayments(newValue) {
      this.periodicPayments = newValue;
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/booking.css";
@import "../../assets/styles/global.css";
@import "../../assets/styles/listings-view.css";
</style>



// WEBPACK FOOTER //
// src/components/bookings/bookingOverview.vue